import * as yup from "yup";

const validation = (messages, { profile, isTerritorial }) => {
  return yup.object().shape({
    healthInsuranceRightsCertificate: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(1, messages.ONE_FILE),

    paymentAccount: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(1, messages.ONE_FILE),

    cin: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(2, messages.ONE_FILE),

    proofOfEligibility: isTerritorial
      ? yup
          .array()
          .of(
            yup.object().shape({
              name: yup.string().required(messages.REQUIRED),
            }),
          )
          .required(messages.REQUIRED_ATTACHMENT)
          .min(1, messages.REQUIRED_ATTACHMENT)
          .max(1, messages.ONE_FILE)
      : yup.mixed().notRequired(),
  });
};

export default validation;
